export default "__VITE_ASSET__rONhP8pV__";